import Leaf from './Leaf.js';
import Experiment from './Experiment.js';
import { random, randomChange, addConfigRules, addCSSPoppy } from './helpers.js';
import importNames from './importNames.js';

// const io = require('socket.io-client');
// let socket;



(async ()=> {

    const C = await fetch('./themes/ww1/roll_of_honor/configurable.json').then(r=>r.json());
    window.C = C;

    // if (!C.debug) {
    //     socket = io();
    //     socket.on('log', function(m){
    //         console.log(m);
    //     });
    // }

    addConfigRules(C);

    function createInitialLeaves() {
        for (let i = 0; i< C.leafN; i++) {
            const leaf = new Leaf(tut);
            tut.scene.add(leaf.object);
            leaf.startFall();
            leafs.push(leaf);

            leaf.object.visible = false;
            delay += 100;
            setTimeout(()=>{
                leaf.refresh();
                leaf.object.visible = true;
            }, (Math.random() * 700) + delay);
        }
    }


    importNames();

    /* Let's experiment */
    const tut = new Experiment();
    tut.getPerspectiveCamera();
    tut.directionalLight();
    tut.ambientLight();



    const leafs = [];
    window.leafs = leafs;
    let delay = 0;
    function createLeaf() {
        const leaf = new Leaf(tut, false);
        leaf.refresh();
        leafs.push(leaf);
        tut.scene.add(leaf.object);
        leaf.startFall();
    }

    function killLeaf(leaf, i) {
        tut.scene.remove(leaf.object);
        leaf.kill();
        leafs.splice(i, 1);
    }
    window.killLeaf = killLeaf;
    createInitialLeaves();


    // if (!C.debug) {
    //     socket.emit('log', 'Client start up');
    //
    //     socket.on('trigger', ()=>{
    //         console.log('Triggered by yocto');
    //         addCSSPoppy().onfinish = createLeaf;
    //     });
    // }

    var poppyLink = document.getElementById("poppy-link");

    poppyLink.addEventListener('click', ()=>{
        addCSSPoppy().onfinish = createLeaf;
    });




    function renderWall() {
        const roundTimestamp = Date.now();
        leafs.map(function(leaf, i) {
            leaf.update();
            if (!leaf.isBelowView(leaf.object)) {
                tut.scene.remove(leaf.object);

                /* Age leafs and remove them here */
                if ((roundTimestamp - leaf.born) > (C.leafAge)) {
                    killLeaf(leaf, i);
                    return;
                }

                leaf.refresh();
                tut.scene.add(leaf.object);
                if (leaf.special) { leaf.cancelSpecial() }
            }
        });

        tut.render.call(tut);
        setTimeout(renderWall, 0);
    }
    renderWall();
})();

if ('serviceWorker' in navigator) {
    // Register a service worker hosted at the root of the
    // site using the default scope.
    navigator.serviceWorker.register('./sw.js').then(function(registration) {
      console.log('Service worker registration succeeded:', registration);
    }).catch(function(error) {
      console.log('Service worker registration failed:', error);
    });
  } else {
    console.log('Service workers are not supported.');
  }



// WEBPACK FOOTER //
// ./roll_of_honor/javascript/scripts.js